import React from 'react';
import { Menu } from './Menu';

interface Props {
    children: React.ReactNode
};

function Layout({ children }: Props) {
    return (
        <div className="application">
            <Menu />
            <div className="main">
                {children}
            </div>
        </div>
    );
}

export default Layout;

